module.exports = __webpack_public_path__ + "img/empty-profile-picture.0f16ef6a.png";